import { render, staticRenderFns } from "./moneyList.vue?vue&type=template&id=b22c568e&scoped=true&"
import script from "./moneyList.vue?vue&type=script&lang=js&"
export * from "./moneyList.vue?vue&type=script&lang=js&"
import style0 from "./moneyList.vue?vue&type=style&index=0&id=b22c568e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22c568e",
  null
  
)

export default component.exports